import React, { useEffect } from 'react';
import { isIPad13, isTablet } from "react-device-detect";
import { css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import BodyText from 'components/atoms/BodyText';
import Select from 'components/atoms/Select';
import useEmploymentOptions from 'hooks/useEmploymentOptions';
import SelectForm from 'components/molecules/SelectForm';

const EmploymentFilter: React.FC<{
  employmentId: string;
  setEmploymentId: (employmentId: string) => void;
  id?: string;
  defaultValue?: any
}> = ({ employmentId, setEmploymentId, id= '0', defaultValue }) => {
  const employmentOptions = useEmploymentOptions();

  useEffect(() => {
    if(employmentId !== null){
      sessionStorage.setItem(`${id}/sessionData${window.location.pathname}.selectedEmploymentIdStaffMaster`, employmentId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employmentId])

  useEffect(() => {
    let session = sessionStorage.getItem(`${id}/sessionData${window.location.pathname}.selectedEmploymentIdStaffMaster`);
    if(session !== null){
      setEmploymentId(session);
    }else{
      setEmploymentId(defaultValue || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <FlexBox customStyle={css({padding: '8px', paddingLeft: 0})}>
      <FlexBoxItem basis="100px">
        <BodyText> 雇用形態 </BodyText>
      </FlexBoxItem>
      <FlexBoxItem
        basis={isIPad13 || isTablet ? '650px' : "580px"} 
        customStyle={css(isIPad13 || isTablet ? {marginRight: '-105px', marginLeft: '10px'} : {})}
      >
        <SelectForm
          name="orgState"
          value={employmentId}
          setValue={(arg: string) => { setEmploymentId(arg); }}
          options={employmentOptions}
          placeholder="ホール"
        />
      </FlexBoxItem>
    </FlexBox>
  );
};

export default EmploymentFilter;
